"use strict";
//Portuguese
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Entrada',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Saída',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Cancelar',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Salvar',
  'BACK-BTN-LABEL': 'Costas',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Mudo',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Aguarde',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Auditivo',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Teclado',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Transferir',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'Nova chamada',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Desligar',
  'CALLLIST-NOCALL' : 'Nenhuma Chamada ativa',
  'CANCEL-BTN-LABEL' : 'Cancelar',
  'EMAIL-PLACEHOLDER' : 'Endereço de e-mail',
  'INCOMINGCALL-HEADER' : 'Chamada recebida',
  'INCOMINGCALL-ACCEPT' : 'Aceitar',
  'INCOMINGCALL-DECLINE' : 'Declínio',
  'INCOMINGCALL-VOICEMAIL' : 'Enviar para o correio de voz',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' Digite o endereço de e-mail',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'Digite a senha',
  'LOGIN-CHECKBOX-LABEL' : 'Lembre de mim',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Esqueceu a senha?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Assinar em',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Introduza o seu endereço de e-mail para redefinir sua senha.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Digite a senha completa',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Por favor, indique email válido',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'As senhas devem corresponder',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'reiniciar',
  'LOGIN-RESETPW-INFO-TEXT' : ', Altere sua senha. A senha deve conter pelo menos uma letra, nenhum espaço em branco, que não começar com @, e 8 ou mais caracteres.',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Nova senha',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'Repita a senha',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Alterar',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'cancelar',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Visualização de Alertas',
  'SETTINGS-VERSION' : 'versão ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'Documentação de Ajuda',
  'SETTINGS-CHECKBOX-LABEL' : 'Habilitar',
  'SETTINGS-CHECKBOX-HEADER' : 'Sempre na parte superior?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Fechar Alertas',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Sair',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'Extensão',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Tom de toque',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Dispositivo de Entrada',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Dispositivo de Saída',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Tema de Interface',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Idioma da Interface',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Voltar',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Limpar',
  'CALLHISTORY-HEADER' : 'História',
  'CALLHISTORY-NO-HISTORY-MSG' : 'Sem histórico de chamadas',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'Configurações',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'Limpar',
  'ALERTLOG-HEADER' : 'Alertas',
  'ALERTLOG-NO-ALERT-MSG' : 'Não há alertas disponíveis',
  'UTILITIES-STATUS-ONHOLD' : 'Em espera',
  'UTILITIES-STATUS-MUTED' : 'sem surdina',
  'UTILITIES-STATUS-ACTIVE' : 'Ativo',
  'UTILITIES-STATUS-DIALING' : 'Discagem',
  'ALERTITEM-HEADING-LOGIN' : 'Entrar',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'O nome de usuário ou senha que você digitou está incorreto.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Perdeu a conexão de rede. Verifique o status da conexão.',
  'DIALINPUT-PLACEHOLDER-TEXT' : 'Introduza um número para fazer uma chamada',
  'CALLDETAILS-HOLD' : 'Em espera',
  'CALLDETAILS-MUTED': 'sem surdina',
  'CALLLIST-STATUS-ACTIVE': 'Ativo',
  'CALLLIST-STATUS-DIALING': 'Discagem',
  'CALLHISTORY-STATUS-FAILED': 'Falhou',
  'HEADING-STATUS-CONNECTED' : 'Conectado',
  'HEADING-STATUS-OFFLINE' : 'desconectado',
  'BLIND-BTN-LABEL': 'Cego',
  'ATTENDED-BTN-LABEL': 'Participaram',
  'SOFTPHONE-DTMF-COMMANDS': "Digite o números",
  'ARIA-LOGIN-SIGNIN-BTN': "No botão Login",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "botão Esqueceu a senha",
  'ARIA-CANCEL-BTN': "botão cancelar",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "botão de redefinição de senha",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "Botão Não agora",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'Botão voltar',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'botão Limpar histórico',
  'ARIA-SETTINGS-LOGOUT-BTN': "Botão Logout",
  'ARIA-SETTINGS-VIEWALERT-BTN': "Botão Exibir Alertas",
  'ARIA-SETTINGS-HELPDOC-BTN': "botão de documentação de ajuda",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "botão Alterar senha",
  'ARIA-BACKSPACE-BTN': 'botão de retrocesso',
  'ARIA-DIALING-INPUT-FIELD': 'campo de entrada de discagem',
  'ARIA-HEADER': 'Cabeçalho',
  'ARIA-CLEAR-ALERTS-BUTTON': 'botão Limpar alertas',
  'ARIA-ALERT-LIST': 'lista de alerta',
  'ARIA-CHECKBOX': 'Caixa de seleção',
  'ARIA-SAVE-BTN': 'botão Salvar',
  'ARIA-INPUT-FIELD': 'campo de entrada',
  'ARIA-INPUT': 'Entrada',
  'ARIA-KEYPAD': 'teclado',
  'ARIA-KEY': 'Chave',
  'ARIA-AUDIO-SLIDER': 'controle deslizante de áudio',
  'ARIA-AUDIO-SLIDER-CONTROL': 'controle deslizante de áudio',
  'ARIA-MENU-ITEM': 'Item do menu',
  'ARIA-DROP-DOWN-MENU': 'Menu suspenso',
  'ARIA-BADGE-BUTTON': 'Botão do monograma',
  'ARIA-CALL-DETAIL': 'Detalhe da chamada',
  'ARIA-OPEN-SETTINGS-BUTTON': 'Configurações aberta Botão',
  'LOGIN-INPUT-SHOW': 'Mostrar',
  'LOGIN-INPUT-HIDE': 'Ocultar',
  'UPDATE-HEADER': 'Atualização disponível',
  'UPDATE-MSG': 'Você gostaria de reiniciar o aplicativo agora?',
  'UPDATE-POSTPONE-BUTTON': 'Adie (1 Min)',
  'UPDATE-UPDATE-BUTTON': 'Atualizar',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'adiar Botão',
  'ARIA-UPDATE-UPDATE-BUTTON': 'botão Atualizar',
  'ACTIVECALL-STATUS-RINGING': 'tocando',
  'ACTIVECALL-STATUS-ACTIVE': 'Ativo',
  'ACTIVECALL-STATUS-DIALING': 'Discagem',
  'ACTIVECALL-STATUS-FAILED': 'Falha',
  'CALLHISTORY-TODAY': 'Hoje',
  'CALLHISTORY-YESTERDAY': 'Ontem',
  'ALERT_FORGOT_PASSWORD': 'Esqueceu a senha',
  'ALERT_SETTINGS_WILL_APPLY': 'chamadas ativas; configurações serão aplicadas quando ocioso.',
  'ALERT_DIALING_OPTIONS': 'Opções de discagem',
  'ALERT_DIALING_OPTIONS_BODY': 'Faltando opções de plano de discagem',
  'ALERT_LOGIN': 'Entrar',
  'ALERT_SOFTPHONE_EXTENSION': 'Nenhuma extensão softphone',
  'ALERT_MORE_INFORMATION': 'Para mais informações visite:',
  'ALERT_LOST_CONNECTION': 'Perdeu a conexão de rede. Verifique o status da conexão',
  'ARIA-PLAY-BTN': 'Botão Reproduzir',
  'ARIA-STOP-BTN': 'Botão Parar',
  'CONTACTS-STATUS-ONLINE': 'Conectados',
  'CONTACTS-STATUS-OFFLINE': 'desligada',
  'CONTACTS-STATUS-BUSY': 'Ocupado',
  'CONTACTS-STATUS-UNKNOWN': 'Desconhecido',
  'LABELLEDINPUT-LABEL-EMAIL': "Endereço de e-mail",
  'LABELLEDINPUT-LABEL-PASSWORD': "Senha",
  'LABELLEDINPUT-LABEL-TEXT': "Texto",
  'LABELLEDINPUT-HINT-EMAIL': "Digite um endereço de e-mail válido abaixo.",
  'LABELLEDINPUT-HINT-PASSWORD': "Digite uma senha válida abaixo.",
  'LABELLEDINPUT-HINT-TEXT': "Digite o texto abaixo.",
  'ARIA-ICON-AREA': 'Área de ícones',
  'SETTINGS-ADVANCED-LOGGING': "Logon Avançado",
  'APPMENU-SETTINGS-BTN-LABEL': "Abrir configurações",
  'APPMENU-HELP-BTN-LABEL': "Documentação de ajuda",
  'APPMENU-LOGOUT-BTN-LABEL': "Sair",
  'APPMENU-VERSION': "versão ",
  'HEADER-SETTINGS-TITLE': "Configurações",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Notificações",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Aparência",
  'SETTINGS-CONTACTS-BTN-LABEL': "Contatos",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Solução de problemas",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Ajuste como você recebe atualizações.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Mude a aparência do aplicativo.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Importe seus contatos.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Ferramentas para ajudá-lo a descobrir o que está errado",
  'ARIA-BACK-BTN-LABEL': "Costas",
  'HEADER-BACK-ARIA-LABEL' : 'costas',
  'ENTITYLIST-SEARCH-FOUND': "encontrado.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "Unid",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Novo grupo',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'Nenhum contato encontrado',
  'ENTITYLIST-TRY-IMPORTING': 'Tente importar ou adicionar um contato.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Importar',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Digite o número para enviar ou importar sua lista de contatos em configurações.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Pesquisar contatos",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Adicione um número',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'Nenhuma informação de contato',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Adicione um número para começar',
  'ARIA-CARD-DETAILS-EDIT': 'Editar',
  'ARIA-CARD-DETAILS-DELETE': 'Excluir',
  'SETTINGS-DEVICES-BTN-LABEL': "Dispositivos",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Altere a forma como os seus dispositivos estão configurados.",
  'HEADER-CONTACTS-ARIA-LABEL' : "contatos",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Solução de problemas",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Habilitar registro avançado",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "Quando ativado, o aplicativo criará logs avançados para ajudar a diagnosticar erros de aplicativos.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Registro Avançado',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Alertas",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Visualizar alertas",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Acesse um registro de alertas e logs.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Toque",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Alterar o tom de toque para chamadas de voz recebidas.",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "Padrão",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Luz",
  'APPMENU-DARK-THEME-BTN-LABEL': "Sombrio",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "Sempre no topo",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "Quando ativado, o aplicativo sempre será exibido acima de seus outros aplicativos.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Sempre no topo?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "Tema",
  'SETTINGS-THEMES-DESCRIPTION': "Os temas alteram a aparência geral do aplicativo.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Língua.",
  'SETTINGS-LANGUAGE-DESCRIPTION': "Alterar o idioma altera-o durante todo o aplicativo.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "Dispositivo",
  "SETTINGS-CATEGORY-HEADER-NOTIFICATIONS" : "Notificações",
  "SETTINGS-CATEGORY-HEADER-APPEARANCE" : "Aparência",
  "SETTINGS-CATEGORY-HEADER-CONTACTS" : "Contatos",
  'SETTINGS-INPUT-DEVICE-TITLE': "Dispositivo de entrada",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Defina o dispositivo de áudio que deseja usar para a entrada.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Dispositivo de saída",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Defina o dispositivo de áudio que deseja usar para a saída.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Importar seus contatos",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Selecione sua opção abaixo para importar contatos.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Amostra CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Ao pressionar o botão abaixo, será baixado um arquivo CSV de amostra.",
  'SETTINGS-CONTACTS-BACKUP': 'Cópia de segurança',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Pressionando o botão abaixo, será baixado um backup CSV de seus contatos. Isto é recomendado antes das importações.",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Faça o download do backup',
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Importado",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Importar",
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Adicionar contato',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Cancelar",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Excluir",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Tem certeza de que deseja excluir este contato?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Concluir esta ação removerá permanentemente as informações do contato atual. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Um campo no formulário abaixo tem um erro.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Informação pessoal',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Introduza o primeiro nome',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Introduza o primeiro nome',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Último nome',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Insira o sobrenome',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Empresa',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Digite o nome da empresa',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Números de telefone',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Adicionar telefone',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Cancelar',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Salve',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Novo contato',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Editar Contato',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'Este campo não pode ser deixado em branco.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Número',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Digite um número válido de 10 dígitos.',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Insira numeros...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'Preferido?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Casa',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'O negócio',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'Móvel',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'De outros',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Rótulo',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Selecione o número para ligar',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Preferido',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'Digite um número válido.'

};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-pt.js